import { render, staticRenderFns } from "./projectCreate.vue?vue&type=template&id=5f27bbb8&scoped=true"
import script from "./projectCreate.vue?vue&type=script&lang=js"
export * from "./projectCreate.vue?vue&type=script&lang=js"
import style0 from "./projectCreate.vue?vue&type=style&index=0&id=5f27bbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27bbb8",
  null
  
)

export default component.exports